import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton as CoreRadioButton } from '@vds-core/radio-buttons';
import { colors } from '@vds/theme';
import { BodyConfig, TypographyConfig, Body } from '@vds/typography';
import DefaultIcon from './RadioButtonIcon';
var propTypes = {
  /**
   * If provided, this prop will render the string in bold as a title in a two line radio button label
   */
  label: PropTypes.string,

  /**
   * If provided, the component will be rendered in the inverted color scheme
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  inverted: false
};

var RadioButton = function RadioButton(props) {
  return /*#__PURE__*/React.createElement(CoreRadioButton, _extends({}, props, {
    hoverState: true,
    typescale: TypographyConfig.getTypescale(),
    focusState: true,
    colorConfig: colors,
    bodyConfig: BodyConfig,
    RadioButtonIcon: DefaultIcon,
    marginBottom: "6X",
    maxLabelWidth: "596px",
    padding: "0",
    Body: Body
  }));
};

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;
export default RadioButton;